import { SVGProps } from 'react';

const GitCompareArrows = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v7a2 2 0 0 0 2 2h5m0-12h5a2 2 0 0 1 2 2v7M15 3l-3 3 3 3m4 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6M9 21l3-3-3-3"
    />
  </svg>
);
export default GitCompareArrows;
